import axios from 'axios';
import { authHeader } from './auth-header';

export const whiteListService = {
    getAll,
    create,
    update,
    destroy
};

function getAll({ 
    pageSize, 
    page, 
    search, 
    orderBy, 
    sortColumn  
}) {
    return axios.get('/whitelist-local', {
        params: {
            pageSize,
            page,
            search,
            orderBy,
            sortColumn
        },
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function create(data) {
    return axios.post('/whitelist-local', data, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function update(data, id) {
    return axios.post(`/whitelist-local/${id}`, data, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function destroy(id) {
    return axios.delete(`/whitelist-local/${id}`, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}
